import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import Ctas from '../../../Core/Ctas';

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 3rem 1.5rem;
  gap: 2rem;
  border-radius: 0.75rem;
  background: ${themeGet('colors.white')};
  max-width: ${themeGet('media.grid')};
  width: calc(100% - ${themeGet('media.grid-gutter.2')});
  margin: auto;
  margin-top: calc(-${themeGet('media.grid-gutter.2')} + 0.5rem);
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 2rem 1.5rem;
    gap: 3rem;
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
    margin-top: calc(-${themeGet('media.grid-gutter.4')} + 2.5rem);
    flex-direction: row;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    gap: 6.5rem;
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
    margin-top: calc(-${themeGet('media.grid-gutter.5')} + 4.5rem);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin-top: calc(-${themeGet('media.grid-gutter.5')} + 2.5rem);
  }

  &.spotlight {
    margin: 0 -2.25rem 0;
    gap: 1.5rem;
    padding: 0;
    width: calc(100% + 4.5rem);
    border-radius: 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      gap: 1.25rem;
      flex-direction: column;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      gap: 2.25rem;
      flex-direction: row;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  gap: 1.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 42.5%;
  }

  ${Banner}.spotlight & {
    width: unset;
    gap: 0;
    padding: 0 2.25rem;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      padding: 0 2.25rem 0 0;
    }
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    img {
      margin-left: auto;
      margin-right: 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 40%;
  }

  ${Banner}.spotlight & {
    width: unset;
  }
`;

export const Img = styled(Image)`
  margin: 0 auto;
  width: 100%;
  width: 6.5rem;
  height: 6.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 14rem;
    height: 14rem;
  }

  ${Banner}.spotlight & {
    display: none;
    margin: auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      display: block;
      width: 5.6875rem;
      height: 5.6875rem;
      margin-left: 2.25rem;
      margin-top: 1.25rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin: auto;
      margin-left: 2.25rem;
    }
  }
`;

export const StyledLogo = styled(Image)`
  width: 7.85rem;
  height: 3.25rem;
`;

export const Heading = styled.div`
  p {
    font-size: 1.25rem;
    line-height: 150%;
    font-weight: ${themeGet('fontWeights.medium')};
  }

  ${Banner}.spotlight & {
    margin-top: 0;
    p {
      font-size: 1rem;
      margin-bottom: 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin-top: 1.5rem;
    }
  }
`;

export const StyledCtas = styled(Ctas)`
  margin: unset;
  flex-direction: unset;
`;

export const Body = styled.span`
  ${Banner}.spotlight & {
    margin-bottom: 1.5rem;
  }
`;
